import React from 'react'

/**
 * Schedule Component for Student Dashboard
 * Displays schedule of classes and upcoming events
 */
const Schedule = () => {
  return (
    <div className="schedule-page">
      <h1>My Schedule</h1>
      <p>View your upcoming classes and events.</p>

      <div className="schedule-calendar">
        <h2>Calendar</h2>
        <p>Your calendar will appear here.</p>
      </div>

      <div className="upcoming-events">
        <h2>Upcoming Events</h2>
        <p>Your upcoming events will appear here.</p>
      </div>
    </div>
  )
}

export default Schedule
